import { useCallback, useMemo, useState } from "react";
import { useGomakeAxios, useSnackBar } from "@/hooks";
import { useRecoilState } from "recoil";
import { loadingWithShadowState } from "@/store";
import {useTranslation} from "react-i18next";

const useEditCustomer = () => {
  const { callApi } = useGomakeAxios();
  const [state, setState] = useState<any>({});
  const {setSnackbarStateValue, alertSuccessUpdate } = useSnackBar();
  const [loading,setLoading] = useRecoilState(loadingWithShadowState);
  const { t } = useTranslation();
  const editCustomer = useCallback(
    async (data: any, setData: any) => {
      setLoading(true)
      return new Promise(async (resolve, reject) => {
        try {
            const res = await callApi("PUT", `/v1/customers/update-customer`, {
              customer: data,
            });
            if (res?.success) {
              alertSuccessUpdate();
              resolve(true);
              setLoading(false)
            } else {
              const errorMessage =
                res?.statusCode === 96
                  ? t("alerts.mailAlreadyExists")
                  : res?.message || t("modal.updatedfailed");
              setSnackbarStateValue({
                state: true,
                message: errorMessage,
                type: "error",
              });
              reject("API call failed");
              setLoading(false)
            }
          
        } catch (error) {
          console.error("Error editing customer:", error);
          reject(error);
        }
      });
    },
    [state]
  );


  return {
    state,
    editCustomer,
  };
};

export { useEditCustomer  };